<template>
  <div class="worksheet-form">
    <sidebar class="worksheet-form__sidebar" />
    <vue-scroll key="scroll">
      <drop-area>
        <drag-area />
      </drop-area>
    </vue-scroll>
  </div>
</template>

<script>
  import Sidebar from './sidebar';
  import DropArea from './drop-area';
  import DragArea from './drag-area';

  export default {
    components: {
      Sidebar,
      DropArea,
      DragArea
    }
  };
</script>

<style lang="scss">
  .worksheet-form {
    display: inline-block;
    position: relative;
    width: 100%;
    max-width: 100vw;
    height: calc(100vh - 75px);

    &__sidebar {
      z-index: 4;
    }
  }
</style>
